import { Controller } from '@hotwired/stimulus'
import { csrfParams } from 'util/params'
import { loadScript } from 'util/script'
import { fetchJson } from 'util/fetch'

const AUTHORIZATION_ENDPOINT = '/authorization/google'

// Connects to data-controller="calendar-reconnect"
//
// Re-runs Google consent for an existing, dead calendar connection and refreshes
// its stored tokens via the scope-authorization endpoint. On success the server
// clears the needs_reconnect flag, so we simply reload to drop the banner.
export default class extends Controller {
  static targets = ['button']

  static values = {
    clientId: String
  }

  async connect () {
    await loadScript('google-auth', 'https://accounts.google.com/gsi/client', 'google')

    const { google } = window

    if (!google) {
      return
    }

    this.client = google.accounts.oauth2.initCodeClient({
      client_id: this.clientIdValue,
      scope: this.scopes.join(' '),
      ux_mode: 'popup',
      callback: (response) => this.#handleCodeResponse(response)
    })
  }

  get scopes () {
    return [
      'https://www.googleapis.com/auth/calendar.readonly',
      'https://www.googleapis.com/auth/calendar.events',
      'https://www.googleapis.com/auth/userinfo.email',
      'https://www.googleapis.com/auth/userinfo.profile'
    ]
  }

  reconnect (event = null) {
    if (event) event.preventDefault()

    this.client.requestCode()
  }

  async #handleCodeResponse (response) {
    if (this.hasButtonTarget) this.buttonTarget.disabled = true

    const authorizationResponse = await fetchJson(AUTHORIZATION_ENDPOINT, 'patch', csrfParams({
      code: response.code,
      scope: response.scope,
      purpose: 'calendar'
    }))

    if (authorizationResponse.status === 'connected') {
      window.location.reload()
      return
    }

    if (this.hasButtonTarget) this.buttonTarget.disabled = false
  }
}
